import { cycleCountIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const startCycleCount = unaryRpc({
  name: "startCycleCount" as const,
  input: z.object({ id: cycleCountIdFormat.schema }),
  output: z.object({}),
});

export const cancelCycleCount = unaryRpc({
  name: "cancelCycleCount" as const,
  input: z.object({ id: cycleCountIdFormat.schema }),
  output: z.object({}),
});

export const approveCycleCount = unaryRpc({
  name: "approveCycleCount" as const,
  input: z.object({ id: cycleCountIdFormat.schema }),
  output: z.object({}),
});

export const rejectCycleCount = unaryRpc({
  name: "rejectCycleCount" as const,
  input: z.object({ id: cycleCountIdFormat.schema }),
  output: z.object({}),
});

export const deleteCycleCount = unaryRpc({
  name: "deleteCycleCount" as const,
  input: z.object({ id: cycleCountIdFormat.schema }),
  output: z.object({}),
});

export const updateCycleCountDueDate = unaryRpc({
  name: "updateCycleCountDueDate" as const,
  input: z.object({
    id: cycleCountIdFormat.schema,
    dueAt: z.coerce.date().nullable(),
  }),
  output: z.object({}),
});

export const updateCycleCountAssignee = unaryRpc({
  name: "updateCycleCountAssignee" as const,
  input: z.object({
    id: cycleCountIdFormat.schema,
    assignedUserId: z.string().nullable(),
    assignedRole: z.string().nullable(),
  }),
  output: z.object({}),
});
